<template>
  <div
    class="own-brand-product-detail"
    :style="{background:style.background}"
  >
    <Header
      class="yh-header"
      active="/ownBrandProduct"
      :product-value="productValue"
    />
    <div style="height: 75px" />
    <img
      :src="imgList[0]"
      alt=""
      class="top-img"
    >
    <div
      v-if="isShow"
      class="ofresh"
      @click="handleGoProductList(10)"
    />
    <div
      class="brand-detail-main"
      :style="{width:style.width,height: style.height}"
    >
      <img
        :src="imgList[1]"
        alt=""
      >
      <div
        class="brand-detail"
        :style="{height: style.height}"
      >
        <div
          v-for="(item,i) in firmList"
          :key="i"
          :class="item.value ? 'cur' : ''"
          @click="handleGoProductList(item.value)"
        />
      </div>
    </div>
    <img
      v-for="(item,i) in imgList"
      v-show="![0,1].includes(i)"
      :key="i"
      :src="item"
      alt=""
    >
  </div>
</template>
<script>
import Header from '@/components/Header'

export default {
  name: 'OwnBrandProduct',
  components: {
    Header
  },
  data() {
    const type = this.$route.params.id
    return {
      productValue: this.util.getVariantSession('tagId'),
      isShow: type === 'ofresh',
      style: {
        background: {
          yhnc: '#E4FCDD',
          tq: '#EDF8AF',
          cds: '#BEE8DF',
          ys: '#F0FFE8'
        }[type],
        width: {
          yhnc: '648px',
          tq: '484px',
          cds: '560px',
          ys: '484px'
        }[type],
        height: {
          yhnc: '315px',
          tq: '296px',
          cds: '216px',
          ys: '340px'
        }[type]
      },
      imgList: [
        require(`@/assets/ownBrandProduct/${type}/1.jpg`),
        require(`@/assets/ownBrandProduct/${type}/2.jpg`),
        require(`@/assets/ownBrandProduct/${type}/3.jpg`),
        require(`@/assets/ownBrandProduct/${type}/4.jpg`),
        type !== 'ofresh' && require(`@/assets/ownBrandProduct/${type}/5.jpg`),
        type === 'cds' && require(`@/assets/ownBrandProduct/${type}/6.jpg`)
      ],
      firmList: {         // 商行类型
        yhnc: [  // 永辉农场
          {
            label: '水果商行',
            value: 2
          },
          {
            label: '蔬菜商行',
            value: 3
          },
          {
            label: '水产商行',
            value: 5
          },
          {
            label: '肉禽商行',
            value: 4
          }
        ],
        tq: [ // 田趣
          {
            label: '干杂商行',
            value: 8
          },
          {
            label: '日配商行',
            value: 9
          },
          {
            label: '干货商行',
            value: 1
          }
        ],
        cds: [ // 馋大师
          {
            label: '休闲商行',
            value: 7
          },
          {
            label: '酒水商行',
            value: 6
          }
        ],
        ys: [ // 优颂
          {
            label: '家用商行',
            value: 11
          },
          {
            label: '文家纺商行',
            value: 12
          },
          {
            label: '清洁用品商行',
            value: 10
          }
        ]

      }[type]
    }
  },
  methods: {
    // 查看详情
    handleGoProductList(value) {
      if (value) {
        this.$router.push(`/product/list?firmId=${value}&type=${this.$route.params.id}`)
      }
    }
  }
}
</script>

<style lang="less">
.own-brand-product-detail {
  position: relative;
  img {
    display: block;
    width: 100%;
  }
  .top-img{
    margin-top: -85px;
  }
  .brand-detail-main{
    position: relative;
    margin: 0 auto;
    .brand-detail{
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      justify-content: space-between;
      >div{
        width: 145px;
        height: 100%;
      }
      .cur{
        cursor: pointer;
      }
    }
  }
  .brand-img{
    width: 658px;
    margin:1px auto 50px;
  }
  .ofresh{
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 635px;
    top: 0;
  }
}
</style>
